import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/types/store";
import { fetchPaymentListRequest } from "../../store/slices/payment-slice";
import { PAGE_LIMIT } from "../../constants";
import { ListTable } from "../../components/ListTable";
import {formatDate} from "../../utility/general";

const Payments = () => {
  const dispatch: AppDispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(PAGE_LIMIT);
  const [statusFilter, setStatusFilter] = useState("");

  const { payment_list, loading, pagination, error } = useSelector(
    (state: RootState) => state.payment,
  );

  const payload = {
    page: page,
    limit: limit,
    status: statusFilter,
  };

  useEffect(() => {
    dispatch(fetchPaymentListRequest(payload));
  }, [page, statusFilter]);

  const columns = [
    { key: "paymentRequestId", label: "Product", render: (item: any) => (
      item.paymentRequestId?.appName
    ) },
    { key: "paymentRequestId", label: "Product", render: (item: any) => (
          item.paymentRequestId?.productName
      ) },
    { key: "paymentRequestId", label: "Customer Name", render: (item: any) => (
          item.paymentRequestId?.customerName
      ) },
    { key: "paymentRequestId", label: "Customer Email", render: (item: any) => (
          item.paymentRequestId?.customerEmail
      ) },
    { key: "paymentRequestId", label: "Amount", render: (item: any) => (
          item.paymentRequestId?.paymentData.amount
      ) },
    { key: "orderId", label: "Order Ref"},
    { key: "paymentId", label: "Payment ID", render: (item: any) => {
      if(item){
        console.log(item)
        const paymentIdStr = JSON.stringify(item.paymentId);
        return paymentIdStr.replaceAll('"', "");
      }
      } },
    { key: "createdAt", label: "Date", render: (item: any) => (
          formatDate(item.createdAt)
      ) },
    {
      key: "statusMessage",
      label: "Status",
      render: (item: any) => (
        <span
          className={`${
            item.statusCode === "2"
              ? "status-active"
              : item.statusMessage === "Restricted card"
                ? "status-inactive"
                : "status-pending"
          }`}
        >
          {item.statusCode === "2" ? "Completed" : "Failed"}
        </span>
      ),
    },
  ];

  return (
    <ListTable
      columns={columns}
      title={"Payment Information"}
      page={page}
      setPage={setPage}
      statusFilter={statusFilter}
      loading={loading}
      pagination={pagination}
      error={error}
      list={payment_list}
      setStatusFilter={setStatusFilter}
    />
  );
};

export default Payments;
